module.exports = __webpack_public_path__ + "static/media/google-play-badge-es.2087e4f5.png";